export default {
    'add-a-account': "Add a account",
    logout: "Logout",
    'a-message-to-a-student': 'A message to a student'
}